import React from 'react';
import MonthlyPayment from './MonthlyPayment';
import {
  useHasFinanceFailed,
  useNoVehicle,
  usePriceTerms
} from '../TileKit/hooks';
import { classnames as cx } from '../../utilities';
import './Terms.scss';
import { formatPrice } from './Terms.helpers';

type OwnProps = {
  hasTradeIn?: boolean;
  hasValidTerms?: boolean;
  hidden?: boolean;
  openSoftPullModal: () => void;
  trackMonthlyPaymentClicked: () => void;
  trackMonthlyPaymentCTAClicked: () => void;
};

export default function Terms({
  hasTradeIn = false,
  hasValidTerms = false,
  hidden = false,
  openSoftPullModal,
  trackMonthlyPaymentClicked,
  trackMonthlyPaymentCTAClicked
}: OwnProps): JSX.Element | null {
  const { pricingErrorMessage, totalCashDue = 0 } = usePriceTerms();

  const env = process.env.NODE_ENV;
  const hasIndividualFinanceFailed = useHasFinanceFailed({ env });
  const noVehicle = useNoVehicle();

  if (noVehicle) {
    return (
      <div className={`terms skeleton`} data-qa="base-terms">
        <div className="term-row">
          <div className="down-payment" />
        </div>
        <div className="term-row">
          <div className="monthly-payment" />
        </div>
      </div>
    );
  }

  if (hasIndividualFinanceFailed) {
    return null;
  }

  if (pricingErrorMessage) {
    return (
      <div
        className={cx('terms', 'pricing-error', { hidden })}
        data-qa="base-terms"
      >
        {pricingErrorMessage}
      </div>
    );
  }

  return (
    <div className={cx('terms', { hidden })} data-qa="base-terms">
      <div className="term-row">
        <MonthlyPayment
          hasValidTerms={hasValidTerms}
          openSoftPullModal={openSoftPullModal}
          trackMonthlyPaymentClicked={trackMonthlyPaymentClicked}
          trackMonthlyPaymentCTAClicked={trackMonthlyPaymentCTAClicked}
        />
      </div>
      <div className="term-row">
        <div
          data-down-payment={totalCashDue}
          className="down-payment"
          data-qa="down-payment"
        >
          ${formatPrice(totalCashDue)} cash down
        </div>
      </div>
      {hasTradeIn && (
        <div className="term-row">
          <div className="trade-in">with trade-in</div>
        </div>
      )}
    </div>
  );
}
